module.exports = __webpack_public_path__ + "img/calendario.f1a9b5cd.svg";